import { render, staticRenderFns } from "./BlocoDadosTerritorioMonitoramentoSocioambiental.vue?vue&type=template&id=799e5f73&scoped=true&lang=pug"
import script from "./BlocoDadosTerritorioMonitoramentoSocioambiental.vue?vue&type=script&lang=js"
export * from "./BlocoDadosTerritorioMonitoramentoSocioambiental.vue?vue&type=script&lang=js"
import style0 from "./BlocoDadosTerritorioMonitoramentoSocioambiental.vue?vue&type=style&index=0&id=799e5f73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799e5f73",
  null
  
)

export default component.exports